import React, { useState, useEffect } from 'react'
import ToolCard from './ToolCard'
import ContentCreation from './ContentCreation'
import PaperEntrance from './PaperEntrance'
import StudyRecord from './StudyRecords'
import { isError } from '@utils'
import moment from 'moment'
import Store from 'store'
import { LearnRecords, Homes } from '@services/api'

const styles = {
  rightMenu: {
    width: 310,
    marginLeft: '10px',
    zIndex: 9,
  },
}
interface ITask {
  name: string
  path: string
  key: string
  isShow: boolean
  count: string
}
const Right = (props: any) => {
  /* '内容创作'模块功能配置 */
  const creationArr = [
    {
      // '我的直播'
      name: '我的直播',
      path: '#/home/myLive',
      key: 'live',
      isShow: false,
      count: '0',
    },
  ]
  const [dataList, setDataList] = useState([])
  const [learnRecordView, setLearnRecordView] = useState({})
  const [contentCreationArr, setContentCreationArr] = useState<ITask[]>(creationArr.filter(i => i.isShow))
  const hasOrg = Store.get('hasOrg') || false
  const liveUserInfo = Store.get('liveUserInfo') || {}
  useEffect(() => {
    getLearnRecords()
    if (liveUserInfo?.sid) {
      setAnchorStatus()
    }
  }, [])

  const getLearnRecords = async () => {
    const userInfo = Store.get('sessionInfo') || {}
    const { code, body, message }: any = await LearnRecords.getStudyRecordView(
      userInfo.userId
    )
    if (isError(code, message, props.enqueueSnackbar)) {
      setLearnRecordView({ ...body })
    }
    const result: any = await LearnRecords.queryUserStudyBehaviorList(
      userInfo.userId,
      moment().format('YYYY-MM')
    )
    if (isError(result.code, result.message, props.enqueueSnackbar)) {
      setDataList(result.body.list)
    }
  }

  const setAnchorStatus = async () => {
    const result: any = await Homes.checkIsAnchor()
    if (isError(result.code, result.message, props.enqueueSnackbar)) {
      const { body: { isAnchor } } = result
      const contentArr = creationArr.map((item: ITask) => {
        if (item.key === 'live') {
          return { ...item, isShow: +isAnchor === 1 }
        }
        return item
      })
      console.log(contentArr)
      setContentCreationArr(contentArr.filter(i => i.isShow))
    }
  }

  return (
    <div style={styles.rightMenu}>
      <ToolCard {...props} />
      {
        contentCreationArr.length > 0 && (
          <ContentCreation
            {...props}
            contentCreationArr={contentCreationArr}
          />
        )
      }
      {/* <PaperEntrance /> */}
      {hasOrg && (
        <StudyRecord
          learnRecordView={learnRecordView}
          learnRecordList={dataList}
          {...props}
        />
      )}
    </div>
  )
}
export default Right
